module.exports = __webpack_public_path__ + "static/media/sport-banner-sportsbook.e5b4565e.svg";